export class OptionList {
/**
 * @param axios
 */
  constructor (axios) {
    this.url = process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc';
    this.axios = axios;
  }
  // load shop
  loadShops () {
    return this.axios.get(this.url + '/informations/shops')
      .then(response => {
        const shops = response.data.data || [];
        return shops.map(shop => { return { label: shop.name, code: shop.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadCategories () {
    return this.axios.get(this.url + '/informations/categories')
      .then(response => {
        const categories = response.data.data || [];
        return categories.map(category => { return { label: category.name, code: category.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadRewards () {
    return this.axios.get(this.url + '/informations/rewards')
      .then(response => {
        const rewards = response.data.data || [];
        return rewards.map(reward => { return { label: reward.name, code: reward.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadFloors () {
    return this.axios.get(this.url + '/informations/floors')
      .then(response => {
        const floors = response.data.data || [];
        return floors.map(floor => { return { label: floor.name, code: floor.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadTiers () {
    return this.axios.get(this.url + '/informations/tiers')
      .then(response => {
        const tiers = response.data.data || [];
        return tiers.map(tier => { return { label: tier.name, code: tier.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadZones () {
    return this.axios.get(this.url + '/informations/zones')
      .then(response => {
        const zones = response.data.data || [];
        return zones.map(zone => { return { label: zone.name, code: zone.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
  loadAppOptions () {
    return this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/app')
      .then(response => {
        const apps = response.data.data.apps;
        return apps.map(app => { return { label: app.name, code: app.id }; });
      })
      .catch(error => {
        console.log(error.message || error.response);
        return [];
      });
  }
};
